export const CompanyTypes = [
  { name: "Store", value: "STORE" },
  { name: "Customer", value: "CUSTOMER" },
  { name: "Supplier", value: "SUPPLIER" },
  { name: "Consignee", value: "CONSIGNEE" },
  { name: "Importer", value: "IMPORTER" },
];

export const AddressTypes = [
  { name: "Warehouse", value: "WAREHOUSE" },
  { name: "Office", value: "OFFICE" },
  { name: "Factory", value: "FACTORY" },
];

/* export const StockClasses = [
  { name: "YARN", value: "YARN" },
  { name: "FABRIC", value: "FABRIC" },
]; */

export const OrderStatus = [
  { name: "Open", value: "OPEN" },
  { name: "In-Progress", value: "IN_PROGRESS" },
  { name: "Complete", value: "COMPLETE" },
  { name: "Processing", value: "PROCESSING" },
  { name: "Verified", value: "VERIFIED" },
  { name: "Verification", value: "VERIFICATION" },
];

export const StockIssueOrderStatus = [
  { name: "Issue", value: "ISSUED" },
  { name: "Complete", value: "COMPLETE" },
  { name: "Processing", value: "PROCESSING" },
];

export const MaterialRequestStatus = [
  { name: "Open", value: "OPEN" },
  { name: "Verification", value: "VERIFICATION" },
  { name: "Prepare", value: "PREPARE" },
  { name: "Ready", value: "READY" },
  { name: "Assigned", value: "ASSIGNED" },
  { name: "Processing", value: "PROCESSING" },
  { name: "Complete", value: "COMPLETE" },
];

export const StockStatuses = [
  { name: "Available", value: "AVAILABLE" },
  { name: "Requested", value: "REQUESTED" },
  { name: "Ready", value: "READY" },
  { name: "Loaded", value: "LOADED" },
  { name: "Issued", value: "ISSUED" },
  { name: "Unloaded", value: "UNLOADED" },
  { name: "Delivered", value: "DELIVERED" },
  { name: "Signoff", value: "SIGNOFF" },
];

export const InspectionStatuses = [
  { name: "Unrestricted", value: "UR" },
  { name: "Damage", value: "D" },
  { name: "Rejected", value: "R" },
  { name: "Write off", value: "W" },
  { name: "QA Pending", value: "Q" },
  { name: "Sample", value: "S" },
];

export const PriorityStatuses = [
  { name: "Urgent", value: "URGENT" },
  { name: "Highest", value: "HIGHEST" },
  { name: "High", value: "HIGH" },
  { name: "Medium", value: "MEDIUM" },
  { name: "Low", value: "LOW" },
  { name: "Lowest", value: "LOWEST" },
  { name: "Ok", value: "OK" },
];

export const StockCheckTypes = [
  { name: "Cycle Count", value: "CYCLE_COUNT" },
  { name: "Full Count", value: "FULL_COUNT" },
];

export const StockCheckStatus = [
  { name: "Open", value: "OPEN" },
  { name: "In progress", value: "IN_PROGRESS" },
  { name: "Complete", value: "COMPLETE" },
];

export const ReasonForCancel = [{ name: "Not found", value: "NOT_FOUND" }];

export const PackingStatus = [
  { name: "NEW", value: "NEW" },
  { name: "RETURN", value: "RETURN" },
];

export const ReceiptType = [
  { name: "DIRECT", value: "TIEP" },
  { name: "INDIRECT", value: "LOCAL" },
];

export const IssueType = [
  { name: "MATERIAL REQUEST", value: "MRN" },
  { name: "JOB", value: "JOB" },
];

export const PurchaseOrderTypes = [
  { name: "Standard Purchase Order", value: "NORMAL_PURCHASE_ORDER" },
  { name: "Draft Purchase Order", value: "DRAFT_NORMAL_PURCHASE_ORDER" },
  { name: "Non Stock Purchase Order", value: "NON_STOCK_PURCHASE_ORDER" },
  {
    name: "Non Stock Draft Purchase Order",
    value: "DRAFT_NON_STOCK_PURCHASE_ORDER",
  },
];

export const DashboardTimeFilterTypes = [
  { name: "YEARLY", value: "YEARLY" },
  { name: "MONTHLY", value: "MONTHLY" },
  { name: "WEEKLY", value: "WEEKLY" },
  { name: "DAILY", value: "DAILY" },
];

export const StockReceiptOrderStage = {
  OPEN: "OPEN",
  UPDATE: "UPDATE",
  COMPLETE: "COMPLETE",
};

export const ReasonTypes = [
  { name: "TRANSFER", value: "TRANSFER" },
  { name: "REQUEST", value: "REQUEST" },
];

export const AgingTimeFrames = [
  { name: "0 - 3 Months", value: "AGE_LT_90" },
  { name: "3 - 6 Months", value: "AGE_90_TO_180" },
  { name: "6 - 9 months", value: "AGE_180_TO_270" },
  { name: "9 - 12 months", value: "AGE_270_TO_360" },
  { name: "Greater than 12 months", value: "AGE_GT_360" },
];

export const TiepType = [
  { name: "TIEP-1", value: "TIEP_1" },
  { name: "TIEP-4", value: "TIEP_4" },
];

export const GuranteeType = [
  { name: "CORPORATE", value: "CORPORATE" },
  { name: "BANK", value: "BANK" },
  { name: "OTHERS", value: "OTHERS" },
];

export const CreditType = [
  { name: "VOUCHER", value: "VOUCHER" },
  { name: "OTHERS", value: "OTHERS" },
];

export const ExportTypes = [
  { name: "DIRECT", value: "DERECT_Export" },
  { name: "INDIRECT", value: "INDERECT_EXPORT" },
];

export const ExportStatus = [
  { name: "OPEN", value: "OPEN" },
  { name: "READY", value: "READY" },
  { name: "ISSUED", value: "ISSUED" },
  { name: "COMPLETED", value: "COMPLETE" },
];

export const ImportStatus = [
  { name: "OPEN", value: "OPEN" },
  { name: "UPDATE", value: "UPDATE" },
  { name: "COMPLETE", value: "COMPLETE" },
];

export const FilterByAges = [
  { name: "0-90", value: "filterAgeLt90" },
  { name: "90-180", value: "filterAge90To180" },
  { name: "180-270", value: "filterAge180To270" },
  { name: "270-360", value: "filterAge270To360" },
  { name: "360+", value: "filterAgeGt360" },
];
export const DocumentType = [
  { name: "BR", value: "BR" },
  { name: "TIEPAPPLICATION", value: "TIEPAPPLICATION" },
  { name: "VAT", value: "VAT" },
];

export const ApplicationStatus = [
  { name: "APPROVED", value: "APPROVED" },
  { name: "REJECTED", value: "REJECTED" },
  { name: "AMENDMENTS", value: "AMENDMENTS" },
  { name: "PENDING", value: "PENDING" },
];

export const DocumentLinkType = [
  { name: "IMPORT", value: "IMPORT" },
  { name: "EXPORT", value: "EXPORT" },
  { name: "BOM", value: "BOM" },
  { name: "RECEIPT", value: "RECEIPT" },
  { name: "RECEIPT_DETAILS", value: "RECEIPT_DETAILS" },
  { name: "BARCODE", value: "BARCODE" },
  { name: "QUICK_RELEASE", value: "QUICK_RELEASE" },
  { name: "REQUEST", value: "REQUEST" },
  { name: "REQUEST_LINE", value: "REQUEST_LINE" },
  { name: "ISSUE", value: "ISSUE" },
  { name: "ISSUE_SUMMARY", value: "ISSUE_SUMMARY" },
  { name: "ISSUE_DETAILED", value: "ISSUE_DETAILED" },
  { name: "ISSUE_MUD_DOC", value: "ISSUE_MUD_DOC" },
  { name: "CYCLE_COUNT", value: "CYCLE_COUNT" },
  { name: "COMPARISON", value: "COMPARISON" },
  { name: "ADJUSTMENT", value: "ADJUSTMENT" },
  { name: "BULK_TRANSFER", value: "BULK_TRANSFER" },
];

export const ReferenceTypeCodes = {
  REGION: "CR",
  COUNTRY: "CC",
  COMPANY_TYPE: "COMPANY_TYPE",
  INDUSTRY_TYPE: "INDUSTRY_TYPE",
  PAYMENT_TERMS: "PT",
  SHIPMENT_MODE: "SM",
  INCOTERMS: "IT",
  PORT: "PO",
  CURRENCY: "CURRENCY",
  PO_TYPE: "PO_TYPE",
  PO_STATUS: "PO_STATUS",
  ADDRESS_TYPE: "ADDRESS_TYPE",
};


export const TiepDocumentType = [
  // { name: "TIEP Application", value: "TIEPAPPLICATION" },
  { name: "Request Letter", value: "REQUESTLETTER" },
  { name: "Ministry of Industries Approval", value: "MIA" },
  { name: "Product Report", value: "PR" },
  { name: "Stock Report", value: "SR" },
  { name: "VAT", value: "VAT" },
  { name: "TIN", value: "TIN" },
  { name: "Business Registration", value: "BR" },
  { name: "Memorandum of Article/ Articles of Association", value: "MOA" },
  { name: "Other Necessary Approvals", value: "ONS" },
  { name: "ID Copy", value: "ID" },
  { name: "Particulars of Director/ Secretary", value: "POD" },
  { name: "Documents to Prove the Ownership of the Warehouse", value: "DPO" },
]

export const TiepSchemaTypes = [
  { name: "TIEP-1", value: "TIEP1" },
  { name: "TIEP-4", value: "TIEP4" },
]

export const tiepApplicationStatuses = [
  { name: "APPLICATION", value: "APPLICATION" },
  { name: "APPROVAL", value: "APPROVAL" },
  { name: "AMENDMENTS", value: "AMENDMENTS" },
  { name: "EXTENSIONS", value: "EXTENSIONS" },
  { name: "CLOSURE", value: "CLOSURE" },
]

